<div class="container">
  <mat-toolbar class="custom-header">
  <span (click)="closeModal()">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
  <h2>{{"PROFILE.NUTRITION.MEAL-PLAN" | translate}}</h2>
  <div class="tabs tabs-tutorial-3">
    <span class="tab" [class.active-tab]="activeTab ==='Breakfast'" (click)="selectTab('Breakfast')">{{"PROFILE.NUTRITION.BREAKFAST" | translate}}</span>
    <span class="tab" [class.active-tab]="activeTab ==='Lunch'" (click)="selectTab('Lunch')">{{"PROFILE.NUTRITION.LUNCH" | translate}}</span>
    <span class="tab" [class.active-tab]="activeTab ==='Dinner'" (click)="selectTab('Dinner')">{{"PROFILE.NUTRITION.DINNER" | translate}}</span>
  </div>

  <div *ngIf="activeTab ==='Breakfast'">
    <div *ngFor="let type of colazione" [class.carbo-focus-tutorial]="type.i18nCategory['IT'] === 'Carboidrati'">
      <h3>{{type.i18nCategory[translate.currentLang.toUpperCase()]}}</h3>
      <div class="info-box" *ngFor="let item of type.foods">
        <p class="data-label">{{item.i18nName[translate.currentLang.toUpperCase()]}}</p>
        <p class="data">{{item.value}} {{item.unit}}</p>
      </div>
    </div>
  </div>
  <div *ngIf="activeTab ==='Lunch'">
    <div *ngFor="let type of pranzo">
      <h3>{{type.i18nCategory[translate.currentLang.toUpperCase()]}}</h3>
      <div class="info-box" *ngFor="let item of type.foods">
        <p class="data-label">{{item.i18nName[translate.currentLang.toUpperCase()]}}</p>
        <p class="data">{{item.value}} {{item.unit}}</p>
      </div>
    </div>
  </div>
  <div *ngIf="activeTab ==='Dinner'">
    <div *ngFor="let type of cena">
      <h3>{{type.i18nCategory[translate.currentLang.toUpperCase()]}}</h3>
      <div class="info-box" *ngFor="let item of type.foods">
        <p class="data-label">{{item.i18nName[translate.currentLang.toUpperCase()]}}</p>
        <p class="data">{{item.value}} {{item.unit}}</p>
      </div>
    </div>
  </div>
</div>
